var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"p-ml-3 p-mb-0"},[_c('h1',[_vm._v(_vm._s(_vm.isAdmin ? ((_vm.company.companyname) + " - "): '')+"Prosjekter")])]),_c('projects')],1)}
var staticRenderFns = []

export { render, staticRenderFns }